import React from 'react'
import { Grid, Icon, Button, Checkbox } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import Labels from './../../../../common/Labels';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import MomentDateAndTime from './../../../../../helpers/momentDateAndTime'

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Summary Card');
    }
})
class Summary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createInitiative: false
        };
        this.handleCheckbox = this.handleCheckbox.bind(this);
    }

    componentWillMount() {
        if('createInitiative' in this.props.selectedPracticeLibrary){
            this.setState({ createInitiative: this.props.selectedPracticeLibrary.createInitiative })
        }
    }
    getAuthor = () => {
        let authors = this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.filter(participant => { return participant.role === 'author' });
        if (authors && authors.length > 0) {
            return authors[0].name;
        }
    }

    isAuthor = () => {
        const loggdinUserId = this.props.user.email;
        let authors = this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.filter(participant => { return participant.role === 'author' });
        if (authors && authors.length > 0) {
            return authors.find(author => author.email === loggdinUserId);
        }
        return null;
    }

    upgradeVersion = async (e) => {
        let payload = {
            _id: this.props.selectedPracticeLibrary._id,
            organizationId: this.props.selectedPracticeLibrary.organizationId,
            accountId: this.props.selectedPracticeLibrary.accountId
        }
        dispatch.lifeCycle.upgradeVersion(payload);
    }

    handleCheckbox(event, data) {
        if('checked' in data){
            this.setState({ createInitiative: data.checked }, () => {
                dispatch.lifeCycle.updatePlaybookBySpecificFields({ _id: this.props.selectedPracticeLibrary._id, createInitiative: this.state.createInitiative });
            });
        }
    }

    render() {
        // let versionButton = null;

        // const scope = this.props.selectedPracticeLibrary.scope;
        // const status = this.props.selectedPracticeLibrary.status;

        // if (this.isAuthor()) {
        //     if (scope === "Private" && status == 4) {
        //         versionButton = (
        //             <div>
        //                 <Button className="button-info" onClick={this.upgradeVersion}>
        //                     <span style={{ fontWeight: "400" }}>New Version</span>
        //                 </Button>
        //             </div>
        //         )
        //     }
        // }

        return (
            <Grid columns={4} >
                <Grid.Row>
                    <Grid.Column width={4}>
                        <Grid.Row style={{display:"flex", flexDirection:"row"}}>
                        {this.state.createInitiative ?
                            <Labels name="Create Initiative Enable" style={{color:"black"}} />:
                            <Labels name="Create Initiative Disable" style={{color:"black"}} />}
                             {(this.props.selectedPracticeLibrary.status === 0 || this.props.isAuthor || this.props.isWorkspaceOwner || this.props.isContributor) ?                           <Checkbox
                                huge
                                style={{marginLeft:"20px"}} 
                                key={this.state.createInitiative} 
                                onChange={(event, data) => this.handleCheckbox(event, data)}
                                toggle={true}
                                checked={this.state.createInitiative}
                                disabled={false}
                                slider={true}
                            />: null}
                        </Grid.Row>
                        <Grid.Row>
                            <Labels
                                name="Name"
                                text={this.props.selectedPracticeLibrary.name} />
                        </Grid.Row>
                        <Grid.Row>
                            <Labels
                                name="Current Status"
                                text={this.props.selectedPracticeLibrary.status === 0 ?
                                    "In Design"
                                    : this.props.selectedPracticeLibrary.status === 1 ? "In Review"
                                        : this.props.selectedPracticeLibrary.status === 2 ? "Approved"
                                            : this.props.selectedPracticeLibrary.status === 3 ? "Rejected"
                                                : this.props.selectedPracticeLibrary.status === 4 ? "Published"
                                                    : this.props.selectedPracticeLibrary.status === 5 ? "Inactive"
                                                        : this.props.selectedPracticeLibrary.status === 6 ? "Clone /Purchased"
                                                            : ''}
                            />
                        </Grid.Row>
                        <Grid.Row>
                            <Labels
                                name="Published On"
                                text={MomentDateAndTime(this.props.selectedPracticeLibrary.updatedAt)} />
                        </Grid.Row>
                        <Grid.Row>
                            <Labels
                                name="Current Version"
                                text={this.props.selectedPracticeLibrary.version} />
                        </Grid.Row>

                        <Grid.Row>
                            <Labels
                                name="Designer"
                                text={
                                    <EllipsisTooltip
                                        name={this.getAuthor()} />

                                } />
                        </Grid.Row>
                        <Grid.Row>
                            <Labels
                                name="Base Id"
                                text= {this.props.selectedPracticeLibrary.baseId}
                                 />
                        </Grid.Row>
                    </Grid.Column>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={5}>
                        <Labels
                            name="Overview"
                            text={
                                <span>
                                    <div style={{ 'margin': '8px 0' }}>
                                        <Icon name="sitemap" color="grey" />
                                        <span className="ui blue circular label cardLabel">
                                            {this.props.selectedPracticeLibrary.countList ? this.props.selectedPracticeLibrary.countList.activityCount : 0}
                                        </span>
                                        <span> Activities</span>
                                    </div>
                                    <div style={{ 'margin': '8px 0' }}>
                                        <Icon name="group" color="grey" />
                                        <span className="ui blue circular label cardLabel">
                                            {this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants ? this.props.selectedPracticeLibrary.participants.length : 0}
                                        </span>
                                        <span> Participants</span>
                                    </div>
                                    <div style={{ 'margin': '8px 0' }}>
                                        <Icon name="copy" color="grey" />
                                        <span className="ui blue circular label cardLabel">
                                            {this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.totalIntances ? this.props.selectedPracticeLibrary.totalIntances : 0}
                                        </span>
                                        <span> Usage Count</span>
                                    </div>
                                    <div style={{ 'margin': '8px 0' }}>
                                        <Icon name="thumbs up" color="grey" />
                                        <span className="ui blue circular label cardLabel"> 0</span>
                                        <span> Likes / Thumbs-Up</span>
                                    </div>
                                </span>
                            } />
                    {/* {this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.teamId && this.props.selectedPracticeLibrary.teamId.name && <Grid.Row>
                            <Labels
                                name="Selected Team"
                                text= {this.props.selectedPracticeLibrary.teamId.name}
                                 />
                        </Grid.Row>} */}
                    </Grid.Column>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={3}>
                        <Grid.Row>
                            <img src={this.props.selectedPracticeLibrary.picture} className="fitImage" alt={this.props.selectedPracticeLibrary.name} />
                        </Grid.Row>
                        {/* <Grid.Row>
                            {versionButton}
                        </Grid.Row> */}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }
}

export default Summary